import React from 'react';
import { Section } from './Section';
import { ZapOff, BatteryWarning, ShieldAlert } from 'lucide-react';
export const Problema = () => {
  return <Section className="bg-navy-900/50 border-y border-gold/10" data-id="element-195">
      <div className="max-w-4xl mx-auto" data-id="element-196">
        <h2 className="text-3xl md:text-5xl font-serif text-center mb-16" data-id="element-197">
          Operás como una <span className="text-gold italic" data-id="element-198">"esponja"</span>{' '}
          sin saberlo
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-199">
          <div className="space-y-6 text-gray-300 font-light text-lg leading-relaxed" data-id="element-200">
            <p data-id="element-201">
              La mayoría de los ambientes laborales en Argentina hoy son
              laboratorios de estrés y fricción. Absorbes el miedo al despido,
              la competencia tóxica y la mala onda que flota en el aire.
            </p>
            <p data-id="element-202">
              Intentaste dormir más, pero te levantás igual de rota. Intentaste
              ignorarlo, pero terminás con bruxismo o dolor de espalda.
            </p>
            <p className="text-gold font-medium text-xl border-l-2 border-gold pl-4 mt-8" data-id="element-203">
              El problema no es tu capacidad de trabajo; el problema es que tu
              campo energético está abierto y cualquiera puede entrar a robarte
              tu paz.
            </p>
          </div>

          <div className="grid gap-6" data-id="element-204">
            {[{
            icon: ZapOff,
            text: 'Absorbes el estrés ajeno como si fuera propio'
          }, {
            icon: BatteryWarning,
            text: 'Te levantás agotada aunque hayas dormido 8 horas'
          }, {
            icon: ShieldAlert,
            text: 'Tu campo energético está sin protección'
          }].map((item, i) => <div key={i} className="flex items-start gap-4 p-5 rounded-sm border border-gold/10 bg-navy-800/50 hover:border-gold/30 transition-colors" data-id="element-205">
                <div className="p-2 rounded-full bg-gold/10 text-gold shrink-0" data-id="element-206">
                  <item.icon size={24} strokeWidth={1.5} data-id="element-207" />
                </div>
                <p className="text-offwhite font-medium" data-id="element-208">{item.text}</p>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
};